<template>
  <div>
    <v-table>
      <thead>
        <tr>
          <th>{{ $t("attachmentListStrings.filenameTableHeader") }}</th>
          <th />
          <th v-if="showRemove" />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(attachment, index) in attachments"
          :key="index"
        >
          <td>{{ attachment.filename }}</td>
          <td>
            <v-btn
              rounded
              size="small"
              class="primary-inverted-button"
              @click="downloadFile(attachment)"
            >
              {{ $t("attachmentListStrings.labels.downloadButton") }}
            </v-btn>
          </td>
          <td v-if="showRemove">
            <v-btn
              rounded
              size="small"
              class="accent-inverted-button"
              @click="removeFile(index)"
            >
              {{ $t("attachmentListStrings.labels.removeButton") }}
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-table>
  </div>
</template>

<script>
export default {
  name: "AttachmentList",
  props: {
    showRemove: Boolean,
    attachments: {
      default: () => [],
      type: Array
    }
  },
  methods: {
    downloadFile(attachment) {
      this.$emit("download", attachment);
    },
    removeFile(index) {
      this.attachments.splice(index, 1);
    }
  }
};
</script>
